<template>
  <div id="contenedor-main-planeacion-configuracion-firmas">
    <tool-bar
      v-on:nuevaFirma="registrarNuevaFirma">
    </tool-bar>
    <v-container
      fluid>
      <v-card
        flat>
        <v-card-text>
          <listado
            :listado="getFirmas">
          </listado>
        </v-card-text>
      </v-card>
    </v-container>
    <!-- Eliminar firma -->
    <v-dialog
      v-model="mostrarEliminarFirma"
     scrollable
      persistent
      width="600">
      <eliminar-firma
      :firmaEliminar='estaFirma'
      modulo='planeacion'
      v-on:cerrar='cerrarEliminarFirma'>
      </eliminar-firma>
    </v-dialog>
    <!-- Registrar nueva firma -->
    <v-dialog
      v-model="mostrarRegistrarNuevaFirma"
     scrollable
      persistent
      width="600">
      <registrar-nueva
        modulo="planeacion"
        ref="registrarNuevaFirma"
        v-on:cerrar="cerrarRegistrarNuevaFirma">
      </registrar-nueva>
    </v-dialog>
  </div>
</template>

<script>
import FIRMAS_POR_MODULO from '@/graphql/querys/administracion/configuracion/firmas/firmasPorModulo.gql';
import ToolBar from './ToolBar.vue';
import RegistrarNueva from '@/components/administracion/configuracion/firmas/Nueva.vue';
import EliminarFirma from '@/components/administracion/configuracion/firmas/Eliminar.vue';
import Listado from './listado/Main.vue';
import eventBus from '@/helpers/eventBus';

export default {
  name: 'MainPlaneacionConfiguracionFirmas',
  components: {
    ToolBar,
    RegistrarNueva,
    EliminarFirma,
    Listado,
  },
  data() {
    return {
      mostrarRegistrarNuevaFirma: false,
      mostrarEliminarFirma: false,
      estaFirma: '',
    };
  },
  mounted() {
    eventBus.$on('eliminar-planeacion-firma', (firma) => {
      this.mostrarEliminarFirma = true;
      this.estaFirma = firma;
    });
  },
  methods: {
    cerrarEliminarFirma() {
      this.mostrarEliminarFirma = !this.mostrarEliminarFirma;
    },
    cerrarRegistrarNuevaFirma() {
      this.registrarNuevaFirma();
    },
    registrarNuevaFirma() {
      this.mostrarRegistrarNuevaFirma = !this.mostrarRegistrarNuevaFirma;
    },
  },
  apollo: {
    firmasPorModulo: {
      query: FIRMAS_POR_MODULO,
      variables() {
        return {
          modulo: 'planeacion',
        };
      },
    },
  },
  computed: {
    getFirmas() {
      if (!this.firmasPorModulo) return [];
      // return this.firmasPorModulo;
      return this.firmasPorModulo.slice().sort((a, b) => a.orden - b.orden);
    },
  },
};
</script>

<style lang="scss">

</style>
